import * as React from 'react';
import { ForeignTravel } from '../../../../policy/policyAPI';
import { DropdownInput, ForeignCountryDropdown, ToggleSwitch } from '../../../../components/forms';
import { Button } from '../../../../components/buttons';
import { IconDelete } from '../../../../components/icons';

interface Props {
	foreignTravelList: ForeignTravel[];
	onForeignTravelAdd: () => void;
	onForeignTravelBlur: (e: any) => void;
	onForeignTravelChange: (e: any, index: number) => void;
	onForeignTravelRemove: (index: number) => void;
}

const ForeignTravelList: React.StatelessComponent<Props> = props => {
	return (
		<fieldset>
			{props.foreignTravelList.map((foreignTravel, index: number) => (
				<div key={index} className="row form-group-set enrollment-foreign-travel-item">
					<div className="col-md enrollment-foreign-travel-item-fields">
						<ForeignCountryDropdown
							labelText="Where?"
							id={`abroadLocation${index}`}
							name="abroadLocation"
							onBlur={props.onForeignTravelBlur}
							onChange={(e: any) => props.onForeignTravelChange(e, index)}
							country={foreignTravel.abroadLocation}
							className="mb-3"
						/>
						{(foreignTravel.abroadLocation === 'Palestine' || foreignTravel.abroadLocation === 'Israel') && (
							<ToggleSwitch
								labelText="Does this include Gaza or the West Bank?"
								id={`abroadIsraelPalestine${index}`}
								name="abroadIsraelPalestine"
								onChildren="Yes"
								offChildren="No"
								onBlur={props.onForeignTravelBlur}
								onChange={(e: any) => props.onForeignTravelChange(e, index)}
								checked={foreignTravel.abroadIsraelPalestine}
								className="mb-3 toggle-yes-no"
							/>
						)}
						<DropdownInput
							labelText="For how long?"
							name="abroadDuration"
							value={foreignTravel.abroadDuration}
							onBlur={props.onForeignTravelBlur}
							onChange={(e: any) => props.onForeignTravelChange(e, index)}
							defaultOption="-"
							options={[
								{
									value: '0-4',
									text: 'Less than 4 weeks'
								},
								{
									value: '4-12',
									text: '4-12 weeks'
								},
								{
									value: '13-26',
									text: '13-26 weeks'
								},
								{
									value: '26+',
									text: 'More than 26 weeks'
								}
							]}
							className="mb-2"
						/>
					</div>
					<div className="col-md-auto">
						<Button
							onClick={() => props.onForeignTravelRemove(index)}
							className="btn-icon btn-icon-primary px-0 form-group-set-remove"
						>
							<IconDelete />
							<span className="align-middle ml-2 d-sm-none">Remove</span>
						</Button>
					</div>
				</div>
			))}
			<div className="enrollment-foreign-travel-item">
				<Button onClick={props.onForeignTravelAdd} className="btn-outline-primary">
					<span className="align-middle mx-2">Add Country</span>
				</Button>
			</div>
		</fieldset>
	);
};

export default ForeignTravelList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/activitiesQuestions/ForeignTravelList.tsx